<template>
   <div class="product-form-wrapper">
      <div class="row product-form-container">
         <!-- Columna izquierda -->
         <div class="col-md-6 left-column">
            <!-- Información básica -->
            <div v-if="showSections.basicInfo" class="row">
               <!-- Nombre del producto -->
               <div class="col-md-12">
                  <div class="form-group">
                     <label for="nameProducto">
                        <strong>{{ $t("nombreProducto") }} <span style="color: red">*</span></strong>
                     </label>
                     <input type="text" class="form-control" :class="{
                        'is-valid': nameValidation.valid,
                        'is-invalid': nameValidation.invalid
                     }" id="nameProducto" :placeholder="$t('introduzcaNombre')" :value="product.nombreProducto"
                        @input="updateField('nombreProducto', $event.target.value)" :disabled="true" ref="name"
                        :aria-invalid="nameValidation.invalid" readonly />
                     <input type="hidden" :value="product.xname" @input="updateField('xname', $event.target.value)" />
                     <!-- <small class="form-text text-muted">
                     {{ (product.nombreProducto && product.nombreProducto.length) || 0 }}/{{ maxNameLength }}
                  </small> -->
                  </div>
               </div>

               <!-- Descripción -->
               <div class="col-md-12">
                  <div class="form-group">
                     <label for="descripcionProducto">
                        <strong>{{ $t("descripcion") }}</strong>
                     </label>
                     <input type="text" class="form-control" id="descripcionProducto"
                        :placeholder="$t('introduzcaDescripcion')" :value="product.descripcion"
                        @input="updateField('descripcion', $event.target.value)" :disabled="disabled" />
                  </div>
               </div>

               <!-- Categoría fija para CON/SUPLEMENTO (solo lectura) -->
               <div v-if="product.type === 'con' || product.type === 'suplemento'" class="col-md-12">
                  <div class="form-group">
                     <label><strong>{{ $t("category") }}</strong></label>
                     <input type="text" class="form-control bg-light"
                        :value="product.type === 'con' ? 'CON' : 'SUPLEMENTO'" disabled readonly />
                  </div>
               </div>

               <!-- Codigo de barras -->
               <div class="col-md-12">
                  <div class="form-group" v-if="!notBasicProduct">
                     <label for="barcodeProducto">
                        <strong>{{ $t("codigoDeBarra") }}</strong>
                     </label>
                     <input type="text" class="form-control" id="barcodeProducto"
                        :placeholder="$t('introduzcaCodigoDeBarras')" :value="product.codigoBarras"
                        @input="updateField('codigoBarras', $event.target.value)" :disabled="disabled" />
                  </div>
               </div>

               <!-- Precio para suplementos -->
               <div v-if="showSections.suplementPrice || product.type === 'suplemento'" class="form-group col-md-6">
                  <label class="form-control-label">
                     <strong>{{ $t("precio") }} <span style="color: red">*</span></strong>
                  </label>
                  <div class="input-group">
                     <vue-numeric class="form-control form-control-lg text-right" style="height: auto; padding: 0.5rem;"
                        :class="{
                           'is-valid': product.precioSuplemento > 0,
                           'is-invalid': product.precioSuplemento === 0
                        }" :value="product.precioSuplemento || 0" @input="updateField('precioSuplemento', $event)"
                        :disabled="disabled" :precision="2" :min="0" :empty-value="0" separator="," currency=" €"
                        currency-symbol-position="suffix" />
                  </div>
               </div>

            </div>
         </div>

         <!-- Columna derecha -->
         <div class="col-md-6 right-column">
            <!-- Sección de Color Picker - Mostrar en la columna derecha para todos los productos -->
            <div v-if="showSections.colorPicker" class="color-picker-section">
               <!-- Campo de orden para productos no normales -->
               <div class="form-group">
                  <label for="orden">
                     <strong>{{ $t("orden") }}</strong>
                  </label>
                  <input type="text" class="form-control" id="orden" :placeholder="$t('orden')" :value="product.orden"
                     @input="updateField('orden', $event.target.value)" :disabled="disabled" />
               </div>
               <div class="form-group">
                  <label for="colorSelector">
                     <strong>{{ $t("colorBoton") }} <span style="color: red">*</span></strong>
                  </label>
                  <div class="color-grid">
                     <div v-for="color in [
                        { value: 'amarillo', code: '#ffec9f' },
                        { value: 'rojo', code: '#ffbbbb' },
                        { value: 'verde', code: '#c1ffc1' },
                        { value: 'morado', code: '#ffbfff' },
                        { value: 'blanco', code: '#FFFFFF' },
                        { value: 'azul', code: '#cad3ff' },
                        { value: 'naranja', code: '#ffa54a' },
                        { value: 'gris', code: '#bbbbbb' },
                        { value: 'negro', code: '#000000' }
                     ]" :key="color.value" class="color-option">
                        <div class="radio">
                           <input type="radio" v-model="product.color" :value="color.value" :name="'colors-' + _uid"
                              :checked="product.color === color.value" class="color-radio">
                           <label>
                              <div class="colorWrap" :style="{
                                 backgroundColor: color.code,
                                 border: color.value === 'blanco' ? '1px solid #ddd' : 'none'
                              }"></div>
                           </label>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <!-- Sección de Nombres de Tarifas -->
         <div class="row mt-4 justify-content-center">
            <div class="col-12">
               <div v-if="showSections.pricing" class="rates-container">
                  <div class="rates-grid">
                     <!-- Tarifa 1 (Siempre visible) -->
                     <div class="rate-item">
                        <div class="rate-header">
                           <label class="rate-label">
                              <input type="checkbox" class="rate-checkbox" v-model="product.selPrice1"
                                 @change="[updateField('selPrice1', $event.target.checked)]">
                              {{ $t("tarifa1") }}
                           </label>
                        </div>
                        <div class="rate-input">
                           <input type="text" class="form-control"
                              :class="{ 'is-valid': product.namePrice1 && product.namePrice1.trim() !== '' }"
                              :placeholder="$t('nombreTarifa1')" :value="product.namePrice1"
                              @input="updateField('namePrice1', $event.target.value)" />
                        </div>
                     </div>

                     <!-- Tarifa 2 -->
                     <div class="rate-item">
                        <div class="rate-header">
                           <label class="rate-label">
                              <input type="checkbox" class="rate-checkbox" v-model="product.selPrice2"
                                 @change="[updateField('selPrice2', $event.target.checked)]">
                              {{ $t("tarifa2") }}
                           </label>
                        </div>
                        <div class="rate-input">
                           <input type="text" class="form-control"
                              :class="{ 'is-valid': product.namePrice2 && product.namePrice2.trim() !== '' }"
                              :placeholder="$t('nombreTarifa2')" :value="product.namePrice2"
                              @input="updateField('namePrice2', $event.target.value)" />
                        </div>
                     </div>

                     <!-- Tarifa 3 -->
                     <div class="rate-item">
                        <div class="rate-header">
                           <label class="rate-label">
                              <input type="checkbox" class="rate-checkbox" v-model="product.selPrice3"
                                 @change="updateField('selPrice3', $event.target.checked)">
                              {{ $t("tarifa3") }}
                           </label>
                        </div>
                        <div class="rate-input">
                           <input type="text" class="form-control"
                              :class="{ 'is-valid': product.namePrice3 && product.namePrice3.trim() !== '' }"
                              :placeholder="$t('nombreTarifa3')" :value="product.namePrice3"
                              @input="updateField('namePrice3', $event.target.value)" />
                        </div>
                     </div>

                     <!-- Tarifa 4 -->
                     <div class="rate-item">
                        <div class="rate-header">
                           <label class="rate-label">
                              <input type="checkbox" class="rate-checkbox" v-model="product.selPrice4"
                                 @change="updateField('selPrice4', $event.target.checked)" />
                              {{ $t("tarifa4") }}
                           </label>
                        </div>
                        <div class="rate-input">
                           <input type="text" class="form-control"
                              :class="{ 'is-valid': product.namePrice4 && product.namePrice4.trim() !== '' }"
                              :placeholder="$t('nombreTarifa4')" :value="product.namePrice4"
                              @input="updateField('namePrice4', $event.target.value)" />
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <!-- Tabla de configuración por departamentos (solo para productos normales) -->
            <div v-if="product.type === 'normal' && showDepartmentsTable" class="col-12 mt-3">
               <div class="card mb-4">
                  <div class="card-header py-2 px-0">
                     <h4 class="card-title mb-0">{{ $t("configuracionPorDepartamento") }}</h4>
                  </div>
                  <div class="card-body p-0">
                     <div class="table-responsive">
                        <table class="table table-bordered table-striped tableVentas text-nowrap mb-0">
                           <thead class="thead-dark">
                              <tr>
                                 <th>{{ $t("departamento") }}</th>
                                 <th>{{ $t("categoria") }} <span style="color: red">*</span></th>
                                 <th>{{ $t("iva") }} <span style="color: red">*</span></th>
                                 <!-- <th v-for="rate in [1, 2, 3, 4]" :key="'rate-' + rate"
                                    :class="{ 'text-white-50': rate > 1 && !product[`selPrice${rate}`] }">
                                    {{ cleanRateName(product[`namePrice${rate}`] || $t(`tarifa${rate}`)) }}
                                 </th> -->
                                 <th v-for="rate in [1, 2, 3, 4]" :key="'rate-' + rate">
                                    {{ cleanRateName(product[`namePrice${rate}`] || $t(`tarifa${rate}`)) }}
                                 </th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr v-for="(dept, index) in departments"
                                 :key="'dept-' + (dept.id || index) + '-' + index">
                                 <td>{{ dept.name }}</td>
                                 <td>
                                    <el-select v-model="dept.categoriaId" class="select-default w-100" size="large"
                                       :placeholder="$t('seleccioneCategoria')"
                                       @change="(val) => handleCategoryChange(val, index)">
                                       <el-option v-for="cat in categoriesForDept(dept)" :key="'cat-' + cat.id"
                                          class="select-primary" :label="cat.name || cat.id" :value="cat.id"
                                          :disabled="cat.name === 'CON' || cat.name === 'SUPLEMENTO'" />
                                    </el-select>
                                 </td>
                                 <td>
                                    <el-select v-model="dept.iva" class="select-default w-100" size="large"
                                       :placeholder="$t('iva')">
                                       <el-option
                                          v-for="(iva, index) in Array.from(new Set(dept.availableIvas || filteredIvaTypes || ['21%']))"
                                          :key="'iva-' + iva + '-' + index" class="select-primary" :label="iva"
                                          :value="iva">
                                       </el-option>
                                    </el-select>
                                 </td>
                                 <td v-for="rate in [1, 2, 3, 4]" :key="'price-' + dept.id + '-' + rate">
                                    <!-- <vue-numeric class="form-control text-right" v-model="dept[`price${rate}`]"
                                       :disabled="disabled || (rate > 1 && !product[`selPrice${rate}`])" :class="[
                                          'form-control-lg',
                                          { 'bg-light': rate > 1 && !product[`selPrice${rate}`] }
                                       ]" style="height: auto; padding: 0.5rem 0.75rem;" :precision="2" :min="0"
                                       :empty-value="0" currency="€" separator="," currency-symbol-position="suffix">
                                    </vue-numeric> -->
                                    <vue-numeric class="form-control text-right" v-model="dept[`price${rate}`]" :class="[
                                       'form-control-lg',
                                       { 'bg-light': rate > 1 && !product[`selPrice${rate}`] }
                                    ]" style="height: auto; padding: 0.5rem 0.75rem;" :precision="2" :min="0"
                                       :empty-value="0" currency="€" separator="," currency-symbol-position="suffix">
                                    </vue-numeric>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import VueNumeric from 'vue-numeric'
import { Select, Option, Checkbox } from 'element-ui'

export default {
   name: 'ProductoCombinado',

   components: {
      VueNumeric,
      'el-select': Select,
      'el-option': Option,
      'el-checkbox': Checkbox
   },

   props: {
      // Producto actual
      product: {
         type: Object,
         default: () => ({
            type: 'normal',
            nombreProducto: '',
            xname: '',
            selPrice1: false,
            selPrice2: false,
            selPrice3: false,
            selPrice4: false,
            namePrice1: '',
            namePrice2: '',
            namePrice3: '',
            namePrice4: '',
            categoria: null,
            iva: '21%',
            ivaIncluido: false,
            precioConIva: 0,
            precioSinIva: 0,
            color: '#FFFFFF',
            esMenu: false,
            esOferta: false,
            esNuevo: false,
            esRecomendado: false,
            activo: true,
            descripcion: '',
            observaciones: '',
            codigoBarras: '',
            imagen: null,
            departamentos: [],
            precioSuplemento: 0
         })
      },

      // Lista de TPVs seleccionados
      selectedTpvServerList: {
         type: Array,
         default: () => []
      },

      // Lista de categorías disponibles para el desplegable
      categories: {
         type: Array,
         default: () => []
      },

      // Lista de tipos de IVA disponibles
      ivaTypes: {
         type: Array,
         default: () => []
      },

      // Estado de validación
      validation: {
         type: Object,
         default: () => ({})
      },

      // Si el formulario está deshabilitado/solo lectura
      disabled: {
         type: Boolean,
         default: false
      },

      notBasicProduct: {
         type: Boolean,
         default: false
      },

      // Secciones a mostrar
      showSections: {
         type: Object,
         default: () => ({
            basicInfo: true,
            colorPicker: true,
            pricing: true,
            advanced: true,
            taxes: true,
            suplementPrice: true
         })
      },

      // Longitud máxima para el nombre del producto
      maxNameLength: {
         type: Number,
         default: 75
      },

      productDataInfo: {
         type: Object,
         default: () => ({})
      }
   },

   data() {
      return {
         localProduct: { ...this.product }, // Copia local del producto
         isClosed: false,
         defaultColor: 'amarillo',
         selectedCategoryId: null,
         departments: [], // Se llenará con los departamentos disponibles
         colorOptions: [
            { value: 'amarillo', code: '#ffec9f' },
            { value: 'rojo', code: '#ffbbbb' },
            { value: 'verde', code: '#c1ffc1' },
            { value: 'morado', code: '#ffbfff' },
            { value: 'blanco', code: '#FFFFFF' },
            { value: 'azul', code: '#cad3ff' },
            { value: 'naranja', code: '#ffa54a' },
            { value: 'gris', code: '#bbbbbb' },
            { value: 'negro', code: '#000000' }
         ],
         localCategory: null
      }
   },

   computed: {
      // Mostrar la tabla de departamentos solo para productos normales
      showDepartmentsTable() {
         return this.product.type === 'normal' && this.departments.length > 0;
      },

      // Obtener las tarifas habilitadas (siempre devuelve [1,2,3,4] para mostrar todas las columnas)
      enabledRates() {
         return [1, 2, 3, 4];
      },

      // Filtrar tipos de IVA disponibles
      filteredIvaTypes() {
         return this.ivaTypes || [];
      },

      price1Valid() {
         // Tarifa 1 es válida si tiene un nombre
         return this.product.namePrice1 && this.product.namePrice1.trim().length > 0;
      },

      // Obtener las categorías disponibles
      availableCategories() {
         if (!this.categories || !this.categories.length) {
            console.warn('No hay categorías disponibles');
            return [];
         }

         // Si el primer elemento tiene una propiedad 'categories', devolver esa propiedad
         if (this.categories[0] && Array.isArray(this.categories[0].categories)) {
            return this.categories[0].categories;
         }

         // Si es un array de categorías directas, devolverlo tal cual
         if (Array.isArray(this.categories) && this.categories.length > 0 && this.categories[0].id !== undefined) {
            return this.categories;
         }

         // Si es un array de objetos con categorías anidadas, extraer las categorías
         if (Array.isArray(this.categories) && this.categories.length > 0 && this.categories[0].categorias) {
            const categorias = [];
            this.categories.forEach(business => {
               if (business.categorias && Array.isArray(business.categorias)) {
                  categorias.push(...business.categorias);
               }
            });
            return categorias;
         }

         console.warn('Formato de categorías no reconocido:', this.categories);
         return [];
      },

      categoryDisplayName() {
         // Si hay una categoría seleccionada en el producto, mostrarla
         if (this.product.categoria) {
            if (typeof this.product.categoria === 'string') {
               return this.product.categoria;
            }
            return this.product.categoria.name || '';
         }

         // Si hay un idCategory, buscar la categoría correspondiente
         if (this.product.idCategory) {
            const category = this.availableCategories.find(cat => cat.id === this.product.idCategory);
            if (category) {
               return category.name || `Categoría ${category.id}`;
            }
            return `Categoría ${this.product.idCategory}`;
         }

         // Si no hay categoría seleccionada, mostrar el selector
         return this.$t('seleccioneCategoria');
      },

      hasPrices() {
         this.product.selPrice1 = false;
         this.product.selPrice2 = false;
         this.product.selPrice3 = false;
         this.product.selPrice4 = false;
         this.product.namePrice2 = '';
         this.product.namePrice3 = '';
         this.product.namePrice4 = '';
         return this.product.selPrice1 || this.product.selPrice2 || this.product.selPrice3 || this.product.selPrice4;
      },

      filteredIvaTypes() {
         // Filtrar la opción 'No Aplica' si no es necesaria
         return this.listIva || this.listaTipoIva || [];
      },

      // Propiedad computada para verificar si el nombre es válido según la longitud máxima
      isNameValid() {
         if (!this.maxNameLength) return true;
         const name = this.product.nombreProducto || '';
         return name.length > 0 && name.length <= this.maxNameLength;
      },

      // Propiedad computada para obtener los caracteres restantes para el nombre
      remainingChars() {
         if (!this.maxNameLength) return 0;
         const nombreLength = (this.product.nombreProducto && this.product.nombreProducto.length) || 0;
         return Math.max(0, this.maxNameLength - nombreLength);
      },

      // Propiedad computada para el estado de validación del nombre
      nameValidation() {
         const hasValue = this.product.nombreProducto && this.product.nombreProducto.trim().length > 0;
         const isValid = hasValue && this.isNameValid;
         return {
            valid: isValid,
            invalid: hasValue && !isValid
         };
      },

      // Propiedad computada para la validación del precio de suplemento
      priceValidation() {
         if (this.product.type === 'suplemento' || this.showSections.suplementPrice) {
            const hasPrice = this.product.precio !== null &&
               this.product.precio !== undefined &&
               this.product.precio > 0;
            return {
               valid: hasPrice,
               invalid: !hasPrice
            };
         }
         return { valid: true, invalid: false };
      },

      // Manejar cambios de precio (ahora solo nombres de tarifas)
      handlePriceChange(priceField, value) {
         // Este método se mantiene por compatibilidad pero ya no actualiza precios
         // Solo actualiza el nombre de la tarifa si está vacío
         const priceNumber = priceField.replace('price', '');
         const nameField = `namePrice${priceNumber}`;

         if ((!this.product[nameField] || this.product[nameField].trim() === '') && value) {
            this.updateField(nameField, `Tarifa ${priceNumber}`);
         }
      },

      // Manejar descarga de código de barras
      downloadBarcode() {
         this.$emit('download-barcode');
      },

      // Prevenir envío del formulario al presionar Enter
      preventSubmit(event) {
         if (event.key === 'Enter') {
            event.preventDefault();
         }
      },

      // Prevenir comas decimales en entradas numéricas
      evitarComasDecimales(event) {
         if (event.key === ',') {
            event.preventDefault();
         }
      }
   },

   watch: {
      // Actualizar localProduct cuando cambie la prop product
      product: {
         handler(newVal) {
            this.localProduct = { ...newVal };
         },
         deep: true
      },
      // Observar cambios en las categorías o TPVs para inicializar departamentos
      categories: {
         immediate: true,
         handler() {
            this.initializeDepartments();
         }
      },

      // Observar cambios en la lista de TPVs seleccionados
      selectedTpvServerList: {
         immediate: true,
         deep: true,
         handler() {
            this.initializeDepartments();
         }
      },

      // Observar cambios en los departamentos para sincronizar con el padre
      departments: {
         deep: true,
         handler() {
            if (this.product.type === 'normal') {
               this.syncWithParent();
            }
         }
      },

      // Los cambios en las tarifas ya no afectan a la tabla de departamentos
      'product.selPrice2': function (newVal) {
         // No hacer nada, solo mantener el estado
      },
      'product.selPrice3': function (newVal) {
         // No hacer nada, solo mantener el estado
      },
      'product.selPrice4': function (newVal) {
         // No hacer nada, solo mantener el estado
      },

      // Observar cambios en nombres de tarifas
      'product.namePrice1': function () {
         this.syncWithParent();
      },
      'product.namePrice2': function () {
         this.syncWithParent();
      },
      'product.namePrice3': function () {
         this.syncWithParent();
      },
      'product.namePrice4': function () {
         this.syncWithParent();
      },

      // Observar cambios en campos básicos del producto
      'product.nombreProducto': function () {
         this.syncWithParent();
      },
      'product.descripcion': function () {
         this.syncWithParent();
      },
      'product.codigoBarras': function () {
         this.syncWithParent();
      },
      'product.color': function () {
         this.syncWithParent();
      },
      'product.orden': function () {
         this.syncWithParent();
      },
      'product.iva': function () {
         this.syncWithParent();
      },
      'product.idCategory': function () {
         this.syncWithParent();
      },
   },

   methods: {
      // Método para obtener una categoría por su ID
      getCategoriaById(id) {
         if (!id || !this.categories || !Array.isArray(this.categories)) return null;

         // Buscar en todas las categorías de todos los negocios
         for (const business of this.categories) {
            if (business.categories && Array.isArray(business.categories)) {
               const categoria = business.categories.find(cat => cat.id == id);
               if (categoria) {
                  return categoria;
               }
            }
         }
         return null;
      },

      // Obtengo los datos de departamentos para enviárselos al padre
      getDepartmentsData() {
         if (!this.departments || this.departments.length === 0) {
            console.warn('No hay datos de departamentos disponibles');
            return [];
         }

         return this.departments.map(dept => {
            const deptData = {
               id: dept.id,
               name: dept.name,
               iva: dept.iva,
               categoria: dept.categoria,
               categoriaId: dept.categoriaId,
               price1: dept.price1 || 0,
               price2: dept.price2 || 0,
               price3: dept.price3 || 0,
               price4: dept.price4 || 0,
               availableIvas: dept.availableIvas || []
            };

            if (!deptData.categoriaId && deptData.categoria && deptData.categoria.id) {
               deptData.categoriaId = deptData.categoria.id;
            }

            return deptData;
         });
      },

      updateField(field, value) {
         const updatedProduct = {
            ...this.product,
            [field]: value
         };
         this.$emit('update:product', updatedProduct);
         this.$emit(`update:${field}`, value);
      },

      cleanRateName(name) {
         if (!name) return '';
         // Elimino signos de exclamación y asteriscos
         return name.replace(/[!*]/g, '').trim();
      },

      // Inicializo los departamentos desde las categorías de negocio o TPVs seleccionados
      initializeDepartments() {
         // Solo inicializar departamentos para productos normales
         if (this.product.type !== 'normal') {
            this.departments = [];
            return;
         }

         // Determino la fuente de datos para departamentos
         const sourceData = this.selectedTpvServerList && this.selectedTpvServerList.length > 0
            ? this.selectedTpvServerList
            : this.categories;

         if (!sourceData || sourceData.length === 0) {
            console.warn('No hay datos para departamentos');
            this.departments = [];
            return;
         }

         // Mapeo los datos de origen a la estructura de departamentos
         this.departments = sourceData.map((item, index) => {
            // Extraigo información del item
            const itemInfo = item.item || item;
            const name = itemInfo.nameShow || itemInfo.name || itemInfo.Description ||
               itemInfo.description || itemInfo.Name || itemInfo.No_ || `Departamento ${index + 1}`;
            const id = itemInfo.tpvServer || itemInfo.idTpvServer || itemInfo.id || itemInfo.code || itemInfo.No_ || name;

            // Configuro IVAs disponibles por defecto - no será usado si vienen datos
            const defaultIvas = ['21%', '10%', '4%', '0%'];
            let availableIvas = defaultIvas;
            if (itemInfo.iva1 || itemInfo.iva2 || itemInfo.iva3 || itemInfo.iva4 || itemInfo.iva5) {
               availableIvas = [
                  itemInfo.iva1,
                  itemInfo.iva2,
                  itemInfo.iva3,
                  itemInfo.iva4,
                  itemInfo.iva5
               ].filter(iva => iva && iva !== '0%' && iva !== '0.00');
               if (availableIvas.length === 0) {
                  availableIvas = defaultIvas;
               }
            }

            // Configuro precios iniciales basados en el producto
            const initialPrices = {
               price1: this.product.price1 || 0,
               price2: this.product.price2 || 0,
               price3: this.product.price3 || 0,
               price4: this.product.price4 || 0
            };

            // Buscar la categoría pre-seleccionada desde productDataInfo
            let preselectedCategoria = null;
            let preselectedCategoriaId = null;

            // console.log("Step 0");
            // Verificar si tenemos productDataInfo y tpvs
            if (this.productDataInfo && this.productDataInfo.tpvs) {
               const tpvData = this.productDataInfo.tpvs[id];

               if (tpvData && tpvData.productos && Array.isArray(tpvData.productos)) {
                  // Buscar el producto normal (no con ni suplemento)
                  const productoNormal = tpvData.productos.find(p => {
                     const producto = p.producto || {};
                     const isConSuple = producto.isConSuple === true;
                     const plu3 = (producto.PLU3 || '').toLowerCase();
                     return !isConSuple || (plu3 !== 'CON' && plu3 !== 'SUPLEMENTO');
                  });

                  if (productoNormal && productoNormal.producto) {
                     const idCategoryFromProduct = productoNormal.producto.idCategory;
                     // console.log("Step 1", idCategoryFromProduct);

                     // Buscar esta categoría dentro de las categorías del TPV actual usando categoriesForDept
                     if (idCategoryFromProduct) {
                        // console.log("Step 2");
                        const catsForTpv = this.categoriesForDept({ id });
                        // console.log('Debug:  Tamaño del catsForTpv', Array.isArray(catsForTpv) ? catsForTpv.length : 0, 'for tpv', id);
                        const categoriaEncontrada = (catsForTpv || []).find(cat => {
                           return cat.id && cat.id.toString() === idCategoryFromProduct.toString();
                        });

                        if (categoriaEncontrada) {
                           // console.log("Step 3:", categoriaEncontrada);
                           preselectedCategoria = categoriaEncontrada;
                           preselectedCategoriaId = categoriaEncontrada.id;
                        }
                        // !!! IMPORTANTE: Comentado porque mostraría los ID en lugar de los nombres, solo lo tengo para debug de ciertos casos, no debe ponerse para prod

                        // else {
                        // Fallback: buscar en todas las categorías disponibles por si la lista por TPV no incluye la categoría
                        // const allCats = Array.isArray(this.categories)
                        //    ? (this.categories[0] && Array.isArray(this.categories[0].categories)
                        //       ? this.categories[0].categories
                        //       : this.categories.reduce((acc, cur) => {
                        //            if (cur && Array.isArray(cur.categories)) acc.push(...cur.categories);
                        //            return acc;
                        //          }, []))
                        //    : [];
                        // const catFallback = allCats.find(cat => cat.id && cat.id.toString() === idCategoryFromProduct.toString());
                        // if (catFallback) {
                        //    // console.log('Step 4 (fallback):', catFallback);
                        //    preselectedCategoria = catFallback;
                        //    preselectedCategoriaId = catFallback.id;
                        // }
                        // }
                     }
                  }
               }
            }

            const department = {
               id: id,
               name: name,
               iva: availableIvas[0] || '21%',
               availableIvas: availableIvas,
               categoria: preselectedCategoria,
               categoriaId: preselectedCategoriaId,
               ...initialPrices
            };

            return department;
         });

         // Sincronizo inmediatamente después de inicializar
         this.$nextTick(() => {
            this.syncWithParent();
         });
      },

      // Método para sincronizar datos con el padre cuando cambien
      syncWithParent() {
         const currentData = this.getCurrentFormData();
         this.$emit('update:product', currentData);
      },

      // Manejo el cambio de categoría mejorado
      handleCategoryChange(selectedCategoryId, deptIndex) {
         // console.log('handleCategoryChange llamado con el ID de categoría:', selectedCategoryId, 'para el departamento:', deptIndex);

         if (this.product.type === 'normal' && deptIndex !== undefined && this.departments[deptIndex]) {
            const list = this.categoriesForDept(this.departments[deptIndex]) || [];
            let category = list.find(cat => cat.id === selectedCategoryId);
            if (!category) {
               // Fallback: buscar en availableCategories si no estaba en la lista filtrada
               category = (this.availableCategories || []).find(cat => cat.id === selectedCategoryId);
            }

            if (category) {
               this.$set(this.departments[deptIndex], 'categoria', category);
               this.$set(this.departments[deptIndex], 'categoriaId', category.id);

               // console.log('Categoría establecida para el departamento:', {
               //    deptIndex,
               //    categoryId: category.id,
               //    categoryName: category.name
               // });

               // Sincronizo con el padre después del cambio
               this.syncWithParent();
            } else {
               console.warn('Categoría no encontrada para ID:', selectedCategoryId);
            }
         }
      },

      // Devuelve las categorías del TPV correspondiente a la fila del departamento
      categoriesForDept(dept) {
         if (!dept || !this.categories || !Array.isArray(this.categories)) return [];
         const tpvKey = String(dept.id || '');

         // Buscar entrada cuyo tpvServer/idTpvServer/id coincida con el id del dept
         const entry = this.categories.find(c => String(c.tpvServer || c.idTpvServer || c.id) === tpvKey);
         if (entry && Array.isArray(entry.categories)) return entry.categories;

         // Fallbacks seguros
         if (this.categories[0] && Array.isArray(this.categories[0].categories)) return this.categories[0].categories;
         if (this.categories.length > 0 && this.categories[0].id !== undefined && !this.categories[0].categories) return this.categories;
         return [];
      },

      // Actualizo precios de departamentos (mejorado)
      // Este método ya no es necesario ya que las tarifas no afectan a la tabla de departamentos
      updateDepartmentPrices(rate, enabled) {
         if (!this.departments || this.departments.length === 0) return;

         // console.log(`Actualizando precios para la tarifa ${rate}, habilitada: ${enabled}`);

         if (enabled) {
            // Si se habilita la tarifa, copiar el precio base a todos los departamentos que no tengan precio
            const basePrice = this.product[`price${rate}`] || 0;

            this.departments.forEach((dept, index) => {
               if (!dept[`price${rate}`] || dept[`price${rate}`] === 0) {
                  this.$set(this.departments, index, {
                     ...dept,
                     [`price${rate}`]: basePrice
                  });
               }
            });
         } else {
            // Si se deshabilita la tarifa, mantener los precios pero marcarlos como deshabilitados
            // console.log(`Tarifa ${rate} deshabilitada, precios manteniendo`);
         }
      },

      // Obtengo todos los datos actuales del formulario
      getCurrentFormData() {
         // console.log(`Obteniendo datos actuales del formulario para el tipo de producto: ${this.product.type}`);

         const baseData = {
            nombreProducto: this.product.nombreProducto || '',
            descripcion: this.product.descripcion || '',
            codigoBarras: this.product.codigoBarras || '',
            color: this.product.color || 'amarillo',
            orden: this.product.orden || 999,
            type: this.product.type || 'normal',
            baja: this.product.baja || false,
         };

         if (this.product.type === 'normal') {
            // Para productos normales, incluir toda la información de precios y departamentos
            const normalData = {
               ...baseData,
               idCategory: this.product.idCategory || null,
               iva: this.product.iva || '21%',
               tipoIva: this.product.tipoIva || '21%',

               // Precios base
               price1: this.product.price1 || 0,
               price2: this.product.price2 || 0,
               price3: this.product.price3 || 0,
               price4: this.product.price4 || 0,

               // Selección de tarifas
               selPrice1: this.product.selPrice1 || false,
               selPrice2: this.product.selPrice2 || false,
               selPrice3: this.product.selPrice3 || false,
               selPrice4: this.product.selPrice4 || false,

               // Nombres de tarifas
               namePrice1: this.product.namePrice1 || '',
               namePrice2: this.product.namePrice2 || '',
               namePrice3: this.product.namePrice3 || '',
               namePrice4: this.product.namePrice4 || '',

               // Propiedades adicionales
               esCombo: this.product.esCombo || false,
               tienePeso: this.product.tienePeso || false
            };

            // Incluir datos de departamentos si existen
            if (this.departments && this.departments.length > 0) {
               normalData.departments = this.getDepartmentsData();
            }

            // console.log('Datos del producto normal recopilados:', normalData);
            return normalData;

         } else if (this.product.type === 'con' || this.product.type === 'suplemento') {
            // Para productos CON y SUPLEMENTO
            const specialData = {
               ...baseData,
               idCategory: this.product.idCategory,
               categoria: this.getCategoriaById(this.product.idCategory) || null
            };

            // console.log(`Datos del producto ${this.product.type.toUpperCase()} recopilados:`, specialData);
            return specialData;
         }

         return baseData;
      },

      // Método validateForm mejorado
      validateForm() {
         const errors = [];
         const product = this.product;

         // Validaciones
         // if (!product.nombreProducto || !product.nombreProducto.trim()) {
         //    errors.push(this.$t('productNameRequired') || 'El nombre del producto es obligatorio');
         // }

         if (!product.color) {
            errors.push(this.$t('buttonColorRequired') || 'El color del botón es obligatorio');
         }

         // Validaciones de departamentos para productos normales
         if (product.type === 'normal' && this.showDepartmentsTable) {
            const departments = this.departments || [];
            departments.forEach((dept, index) => {
               const deptName = dept.name || `Departamento ${index + 1}`;

               if (!dept.categoriaId && (!dept.categoria || !dept.categoria.id)) {
                  errors.push(`La categoría es obligatoria para ${deptName}`);
               }

               if (!dept.iva) {
                  errors.push(`El IVA es obligatorio para ${deptName}`);
               }

               // Validaciones de precios para tarifas habilitadas
               [1, 2, 3, 4].forEach(rate => {
                  if ((rate === 1 || product[`selPrice${rate}`]) &&
                     (dept[`price${rate}`] === null || dept[`price${rate}`] === undefined)) {
                     errors.push(`El precio de Tarifa ${rate} es obligatorio para ${deptName}`);
                  }
               });
            });

            // Validaciones de nombres de tarifas
            // [1, 2, 3, 4].forEach(rate => {
            //    if ((rate === 1 || product[`selPrice${rate}`]) &&
            //       (!product[`namePrice${rate}`] || !product[`namePrice${rate}`].trim())) {
            //       errors.push(`El nombre de Tarifa ${rate} es obligatorio`);
            //    }
            // });
         }

         // Validaciones de categoría para CON/SUPLEMENTO
         // if ((product.type === 'con' || product.type === 'suplemento') &&
         //    !product.idCategory && (!product.categoria || !product.categoria.id)) {
         //    errors.push(`La categoría es obligatoria para el producto ${product.type.toUpperCase()}`);
         // }

         // Validación del precio para suplemento
         if (product.type === 'suplemento' &&
            (product.precioSuplemento === null || product.precioSuplemento === undefined || product.precioSuplemento <= 0)) {
            errors.push('El precio es obligatorio para suplementos');
         }

         return {
            isValid: errors.length === 0,
            errors
         };
      },

   },

   created() {
      //   console.log('ProductoCombinado creado - props:', {
      //     product: this.product,
      //     categories: this.categories,
      //     availableCategories: this.availableCategories
      //   });

      // Asegurar que el tipo de producto esté definido
      if (!this.product.type) {
         this.updateField('type', 'normal');
      }

      // Manejar la inicialización según el tipo de producto
      if (this.product.type === 'con' || this.product.type === 'suplemento') {
         const categoryName = this.product.type.toUpperCase();
         //   console.log(`Categoría: ${categoryName}`);

         // Buscar la categoría en las disponibles o crear una si no existe
         let category = this.availableCategories.find(cat => cat.name === categoryName);

         if (!category) {
            // Si no se encuentra la categoría, crear una temporal
            category = { id: null, name: categoryName };
            // console.warn(`Categoría ${categoryName} no encontrada en las categorías disponibles`);
         }

         // Actualizar el producto con la categoría correspondiente
         this.updateField('categoria', category);
         this.updateField('idCategory', category.id);

         // Asegurarse de que no hay departamentos para CON/SUPLEMENTO
         if (this.departments && this.departments.length > 0) {
            this.departments = [];
         }
      } else if (this.product.type === 'normal' && (!this.departments || this.departments.length === 0)) {
         // Para productos normales, inicializar departamentos solo si no existen
         if (this.categories && this.categories.length > 0) {
            this.initializeDepartments();
         }
      }

      // Asegurar que el color esté correctamente inicializado
      this.$nextTick(() => {
         if (!this.product.color) {
            this.updateField('color', 'amarillo');
         }
      });

      // Establecer tipo de IVA predeterminado si no está configurado
      if (!this.product.tipoIva && this.ivaTypes.length > 0) {
         this.updateField('tipoIva', this.ivaTypes[0]);
      }
   }
};

</script>

<style scoped>
/* ==========================================================================
   ESTILOS BASE DEL FORMULARIO DE PRODUCTO
   ========================================================================== */
.card-header {
   padding-left: 0.1em !important;
   padding-top: 0.1em !important;
}

/* Contenedor principal */
.product-form-wrapper {
   width: 100%;
}

.product-form-container {
   width: 100%;
   margin: 0;
   padding: 15px;
}

.product-form-container>* {
   min-width: 0;
}

/* Columnas del formulario */
.left-column,
.right-column {
   margin-top: 0;
   padding: 0 15px;
   display: flex;
   flex-direction: column;
   gap: 20px;
}

/* ==========================================================================
   GRUPOS DE FORMULARIO Y CONTROLES
   ========================================================================== */

.form-group {
   margin-bottom: 1rem;
   padding-bottom: 0.5rem;
   border-bottom: 1px solid #f0f0f0;
}

.form-group:last-child {
   border-bottom: none;
}

.form-group label {
   display: block;
   margin-bottom: 0.5rem;
   font-weight: 500;
   color: #3c4858;
   font-size: 0.9rem;
   text-transform: uppercase;
   letter-spacing: 0.5px;
}

.form-group+.form-group {
   margin-top: 0.5rem;
}

/* Controles del formulario */
.form-control {
   height: calc(2.5em + 0.75rem + 2px);
   padding: 0.1rem 0.75rem;
   font-size: 0.9rem;
   border: 1px solid #d8dde5;
   border-radius: 4px;
   transition: all 0.2s;
   margin-top: 0.5rem;
   width: 100%;
   box-sizing: border-box;
}

.form-control:focus {
   border-color: #5e72e4;
   box-shadow: 0 0 0 0.2rem rgba(94, 114, 228, 0.25);
}

/* Estados deshabilitados */
.form-control:disabled,
.form-control[readonly] {
   background-color: #e9ecef !important;
   opacity: 1;
   cursor: not-allowed;
}

.vue-numeric.disabled,
.vue-numeric[disabled] {
   background-color: #e9ecef !important;
   opacity: 1;
   cursor: not-allowed;
}

/* ==========================================================================
   SELECTOR DE COLORES
   ========================================================================== */

.color-picker-section {
   width: 100%;
}

.color-grid {
   display: grid;
   grid-template-columns: repeat(3, 1fr);
   gap: 16px;
   margin-top: 10px;
   width: 100%;
}

.color-option {
   display: flex;
   align-items: center;
   width: 100%;
   padding: 8px 4px;
   box-sizing: border-box;
   position: relative;
}

.radio {
   width: 100%;
   margin: 0;
   display: flex;
   align-items: center;
   justify-content: center;
   gap: 8px;
}

.radio label {
   display: flex;
   align-items: center;
   cursor: pointer;
   margin: 0;
   padding: 0;
   width: 100%;
   text-align: left;
}

.colorWrap {
   width: 40px;
   height: 40px;
   border-radius: 4px;
   margin: 0 0 0 8px;
   transition: transform 0.2s, box-shadow 0.2s;
   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
   border: 2px solid transparent;
   flex-shrink: 0;
}

.colorWrap:hover {
   transform: scale(1.05);
   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

input[type="radio"] {
   margin: 0;
   cursor: pointer;
   width: 16px;
   height: 16px;
}

input[type="radio"]:checked+label .colorWrap,
input[type="radio"]:checked+.colorWrap {
   border: 2px solid #5e72e4;
   box-shadow: 0 0 0 1px white, 0 0 0 3px #5e72e4;
}

/* ==========================================================================
   GRID DE TARIFAS
   ========================================================================== */

.rates-grid,
.rate-item,
.rate-input,
.rate-input .form-control {
   min-width: 0;
   width: 100%;
   max-width: 100%;
   box-sizing: border-box;
}

.rates-container {
   margin: 0 auto;
   padding: 0 15px;
   width: 100%;
}

.rates-grid {
   display: grid;
   grid-template-columns: repeat(4, 1fr);
   gap: 1rem;
   margin-bottom: 1.5rem;
   width: 100%;
   box-sizing: border-box;
}

.rate-item {
   border: 1px solid #e0e0e0;
   border-radius: 0.5rem;
   padding: 1rem;
   background-color: #fff;
   transition: all 0.3s ease;
   display: flex;
   flex-direction: column;
   min-width: 0;
   width: 100%;
   box-sizing: border-box;
}

.rate-header {
   margin-bottom: 0.75rem;
   flex-shrink: 0;
}

.rate-label {
   display: flex;
   align-items: center;
   font-weight: 600;
   color: #3c4858;
   cursor: pointer;
   margin: 0;
}

.rate-checkbox {
   margin-right: 0.5rem;
   width: 16px;
   height: 16px;
   cursor: pointer;
   flex-shrink: 0;
}

.rate-input {
   width: 100%;
   box-sizing: border-box;
   flex: 1;
   min-width: 0;
}

.rate-input .form-control {
   width: 100%;
   max-width: 100%;
   box-sizing: border-box;
   min-width: 0;
}

/* ==========================================================================
   TABLA DE DEPARTAMENTOS
   ========================================================================== */

.card {
   padding: 15px;
}

.tableVentas thead th {
   background-color: #2c3e50;
   color: white !important;
   font-weight: 600;
   text-transform: uppercase;
   font-size: 0.8rem;
   padding: 0.75rem 0.5rem;
   text-align: center;
   vertical-align: middle;
   border: 1px solid #dee2e6;
}

.tableVentas thead th:disabled,
.tableVentas thead th[disabled],
.tableVentas thead th.text-white-50 {
   color: white !important;
   opacity: 0.75;
}

/* ==========================================================================
   INPUTS ESPECIALES
   ========================================================================== */

/* Input group para código de barras */
.input-group .form-control:not(:first-child) {
   border-top-left-radius: 0;
   border-bottom-left-radius: 0;
}

.input-group-append .btn {
   border-top-left-radius: 0;
   border-bottom-left-radius: 0;
}

/* Selector de categoría deshabilitado */
.category-selector input[disabled] {
   background-color: #fff;
   cursor: not-allowed;
   opacity: 1;
   border: 1px solid #e9ecef;
   color: #495057;
   padding: 0.5rem 0.75rem;
   -webkit-text-fill-color: #495057;
   -webkit-opacity: 1;
   font-size: 0.9rem;
   border-radius: 4px;
   width: 100%;
   height: calc(2.5em + 0.75rem + 2px);
}

/* ==========================================================================
   PRECIO SUPLEMENTO
   ========================================================================== */

/* Estilo para el campo de precio */
.form-control.text-right {
   text-align: right;
   padding-right: 0.75rem;
   border: 1px solid #ced4da;
   border-radius: 0.25rem;
}

/* Estilo para el símbolo del euro */
.vue-numeric .currency-symbol {
   color: #6c757d;
   margin-left: 0.25rem;
}

.form-group.col-md-6 {
   padding-right: 15px;
   padding-left: 15px;
}

/* ==========================================================================
   MEDIA QUERIES RESPONSIVAS
   ========================================================================== */

/* Pantallas grandes a medianas (1375px) */
/* Pantallas grandes (≥1376px) → 4 columnas */

@media (max-width: 1500px) {
   .orden-row {
      min-width: 350px;
   }
}

/* Pantallas medianas (≤1375px) → 2 columnas */
@media (max-width: 1375px) {
   .rates-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 0.875rem;
   }

   .rate-item {
      padding: 0.875rem;
   }

   .rate-input .form-control {
      font-size: 0.875rem;
   }
}

/* Pantallas pequeñas (≤768px aprox.) → 1 columna */
@media (max-width: 768px) {
   .rates-grid {
      grid-template-columns: 1fr;
      gap: 0.75rem;
   }

   .rate-item {
      padding: 0.75rem;
   }

   .rate-input .form-control {
      font-size: 0.85rem;
   }
}
</style>


// WEBPACK FOOTER //
// src/pages/Widgets/MateriasPrimas/MateriaPrimaCombinado.vue